import { Dataset } from '@/shared/Charting/LineChart/lineChart.types.ts'

const findClosestValue = (ts: number, datasets: Dataset[]) => {
  const values: { datasetId: Dataset['id']; value: number; ts: number; dataType: Dataset['type'] }[] = []

  for (const dataset of datasets) {
    let closestTs = 0
    let minDt = Number.MAX_SAFE_INTEGER
    let closestValue = null

    for (const point of dataset.data) {
      const dt = Math.abs(point.ts - ts)
      if (dt < minDt) {
        minDt = dt
        closestTs = point.ts
        closestValue = point.value
      }
    }

    if (closestValue !== null) {
      values.push({ datasetId: dataset.id, value: closestValue, ts: closestTs, dataType: dataset.type })
    }
  }

  return values
}

const lineChartLegendUtils = { findClosestValue }
export default lineChartLegendUtils
